import {isProd} from "../utils/env";

/**
 * Single source of truth for download links to download Photo51 desktop software.
 */
const downloadLinks = {
    internal: {
        // Get the latest version from the update-packages bucket. This is the bucket into which
        // the electron-builder pipeline uploads the latest builds.
        mac: 'https://update-packages.s3.eu-west-1.amazonaws.com/Photo51-Internal-3.0.50-alpha.0.dmg',
        macArm: 'https://update-packages.s3.eu-west-1.amazonaws.com/Photo51-Internal-3.0.50-alpha.0-arm64.dmg',
      win: 'https://update-packages.s3.eu-west-1.amazonaws.com/Photo51-Internal Setup 3.0.49-alpha.0.exe',
    },
    production: {
        // Get the latest version from the update-packages bucket. This is the bucket into which
        // the electron-builder pipeline uploads the latest builds.
      mac: 'https://update-packages.s3.eu-west-1.amazonaws.com/Photo51-3.0.49.dmg',
      macArm: 'https://update-packages.s3.eu-west-1.amazonaws.com/Photo51-3.0.49-arm64.dmg',
      win: 'https://update-packages.s3.eu-west-1.amazonaws.com/Photo51 Setup 3.0.49.exe',
    },
}

export default isProd() ? downloadLinks.production : downloadLinks.internal;
